export default "__VITE_ASSET__DlD4tsCW__"